import React from 'react';
import LearningContentDetailTable from './LearningContentDetailTable';
import ProgramExportTrackTimetableStack from './ProgramExportTrackTimetableStack';
import { PROGRAM_OPERATION_PLAN_TITLE_SUFFIX } from '../../utils/programExportDocumentTitle';
import type { AnnualCrossTopicDetailDocumentPayload } from '../../utils/documentExportPreviewStorage';

export type AnnualCrossTopicDetailExportDocumentProps = {
  payload: AnnualCrossTopicDetailDocumentPayload;
  seqColumnLabel?: string;
};

const AnnualCrossTopicDetailExportDocument = React.forwardRef<
  HTMLDivElement,
  AnnualCrossTopicDetailExportDocumentProps
>(function AnnualCrossTopicDetailExportDocument({ payload, seqColumnLabel }, ref) {
  const { topic, topicTrackLabel, topicTimetableLabel, scope, scopeLabel, rows } = payload;
  const hasTopicStack =
    (topicTrackLabel ?? '').trim().length > 0 || (topicTimetableLabel ?? '').trim().length > 0;

  return (
    <div ref={ref} className="cp-document-export-preview-sheet cp-annual-cross-topic-detail-print-root">
      <div className="cp-annual-cross-topic-detail-subtitle" data-pdf-element="header">
        <span className={`cp-annual-cross-topic-detail-scope cp-annual-cross-topic-detail-scope--${scope}`}>
          {scopeLabel}
        </span>
        {hasTopicStack ? (
          <ProgramExportTrackTimetableStack
            trackLabel={topicTrackLabel ?? ''}
            timetableLabel={topicTimetableLabel ?? ''}
            suffix={PROGRAM_OPERATION_PLAN_TITLE_SUFFIX}
            className="cp-annual-cross-topic-detail-topic cp-annual-cross-topic-detail-topic--stacked"
          />
        ) : (
          <span className="cp-annual-cross-topic-detail-topic" title={topic}>
            {topic}
          </span>
        )}
      </div>
      <div className="cp-annual-cross-topic-detail-table-wrap">
        <LearningContentDetailTable rows={rows} seqColumnLabel={seqColumnLabel} />
      </div>
    </div>
  );
});

export default AnnualCrossTopicDetailExportDocument;
